var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"WaveSurfer",staticClass:"audio-wavesurfer",staticStyle:{"height":"35px","cursor":"pointer!important"}})
}
var staticRenderFns = []

export { render, staticRenderFns }